import { Component, OnInit } from '@angular/core';
import { GoogleService } from 'src/app/services/google.service';
import swal from 'sweetalert2';  
import {NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {

  constructor(public authService: GoogleService,  config: NgbTimepickerConfig) { }
  usuario;
  id_cliente;
  ngOnInit(): void {
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    //var today = new Date();
    //this.nr=20;
    //console.log("id_cliente: "+this.id_cliente)
    this.ls_cliente();      
    try {
      this.usuario=localStorage.getItem("usuario");  
    } catch (error) {
      this.usuario=0;
    }
  }
  calendario_id:any;
  calendarios:any;
  ls_calendarios(){
    let postData={
      id_cliente:this.cliente_id
    };     
     console.log(postData);
    this.authService.service("/api/get_calendarios",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.calendarios=data;
          console.log(data);
          //swal.fire('¡Evento registrado¡ ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_act_imp', '', 'error');
        }); 
  }
  fecha_c : {year:Number, month:Number, day:Number};
  nr=0;
  proyectos:any;
  cliente_id=0;
  pry_($event){
    //console.log($event);
    this.ls_calendarios();
    this.cliente_id=$event;
    this.ls_proyectos()  
  }
  valida_datos(){
    //console.log(this.cliente_id);
    //console.log(this.proyecto_id);
    if(this.cliente_id==undefined || this.cliente_id==0){
      swal.fire('Selecciona al menos cliente', '', 'warning');
      return false;
    }
    if(this.proyecto_id==undefined){
      swal.fire('Selecciona al menos un proyecto', '', 'warning');
      return false;
    }
    if(this.tot_Sel==0){
      swal.fire('Selecciona al menos un evento', '', 'warning');
      return false;
    }
    return true;
  }
  imp_datos(){
    if(this.valida_datos()==false)return;    
    var a=this.hid_sel.split(",");
    console.log("seleccionados:");
    console.log(a);
    for( let j=0;j<this.event.length;j++)
    for( let i=0;i<a.length;i++){      
      if(this.event[j].id==a[i]){
       console.log(this.event[j]);  
        //console.log(this.attendes_(this.event[j].attendees));          
        this.ins_actividad(this.event[j]);
      }
    }
  }
  attendes_(a){
    if(a==undefined)return "''";
    console.log("-attendes-");
    console.log(a);
    console.log(a);
    var s="";
    var x="";
    if(a.length==0){
      x="";
    }else{
      var bndc=0;
      x="";
      var r=0;
      for(let i=0;i<a.length;i++){
        if(a[i].email.includes("garoce.com")){          
          if(r>0)x=x+",',',";
          x=x+"sufijo('"+a[i].email+"')";
          r++;
          bndc=1;
        }
      }
      if(bndc==1){
        x="concat("+x+")";
      }
      
    }
    return x;
  }
  escape_string(e){
    
    return e.replace(/'"<>\n{}]/g, '');
  }
  ins_actividad(ev){
    //console.log(ev);    

    var _fecha=ev.start.dateTime

    var dt = moment(new Date(_fecha), 'DD-MM-YYYY');   
    var sfecha = dt.format('YYYY') + "-" +
             dt.format('MM') + "-" +
             dt.format('DD') + " " +
             dt.format('hh') + ":" +
             dt.format('mm') + ":" +
             dt.format('ss');
    
    let postData={
      id_proyecto:this.proyecto_id,
      fecha:sfecha,
      actividad:(ev.summary==undefined)?"":ev.summary,
      horas:1,
      departamento:'',
      interviene:this.attendes_(ev.attendees),
      medio:1,
      id_usuario:Number(this.usuario),
      avance:100,
      notas: (ev.description==undefined)?"":this.escape_string(ev.description),
      htmllink:ev.htmlLink,
      id_google:ev.id
    };
    //console.log("postData",postData); 
    //return false; 
    //this.loading = true;            
    this.authService.service("/api/gda_actividades_imp",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          //this.v_proyectos=3; 
          //var id_proyecto_={id:this.hididproyecto};   
          //this.tareas_(id_proyecto_);
          //this.loading = false;            
         

          swal.fire('¡Evento(s) registrado¡ ', '', 'success');
        },
        error => {
          console.log("ini",postData,"---",error); 
            //this.loading=false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_act_imp', '', 'error');
        }); 
  }
  proyecto_id:any;
  ls_proyectos(){
    //this.loading=true;
    //this.v_proyectos=2;
    let postData={
      id_cliente:this.cliente_id,
    };
    //console.log(postData);
    this.authService.service("/api/get_proyectos",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          console.log(data);  
          this.proyectos=data;
          //this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta..! ', '', 'error');
        }); 

  }
  clientes:any;
  ls_cliente(){  
    let postData={
      id_cliente:this.id_cliente
    };
    console.log(postData);
    this.authService.service("/api/get_cliente_id_cliente",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
         
            this.clientes=data;
            console.log("cliente",data);          
  //        this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
//            swal.fire('¡API incorrecta! ', '', 'error');
        });   

  }

  hid_sel="";
  tot_Sel=0;
  ch_id_evtg(id,d){    
    //if(this.hid_sel.toString().length==0)return;
    var a=this.hid_sel.split(",");
    if(a.length>0){      
      //console.log(a);
      if(a.indexOf(id.toString())==-1){
        if (a[0]==""){
          a[0]=id.toString();
        }else{
          a.push(id.toString());
        }
      }else{               
        var i = a.indexOf(id.toString()); 
        a.splice( i, 1 );
      }
      this.hid_sel=a.toString();
    }else{
      this.hid_sel=id.toString();
    }
    this.tot_Sel= a.length;
  }
  event:any;
  calendarid:any;
  public loading;
  ls_list_calendar(){
    if(this.fecha_c==undefined) return; 
    if(this.nr==undefined) return; 
    if(this.nr==0) return; 
    if(this.fecha_c.day==undefined)return;
    this.loading=true;
    this.tot_Sel=0; 
    this.hid_sel="";
    const f_=this.fecha_c.year+"-"+this.fecha_c.month+"-"+this.fecha_c.day + 'T' + '00:00:00.000-05:00'
    let postData={
      fecha_:f_,
      nr:this.nr,
      calendar_id:this.calendarid
    };    
    this.authService.service("/api/google_calendar_list",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
              this.event=data;
              try {
                console.log("eventos:")
                console.log(this.event);
                if(this.event.length>0){
                  for(var i=0;i<this.event.length;i++){
                    if(i>0)this.hid_sel+=",";
                    this.hid_sel+=this.event[i].id;
                  }
                  this.tot_Sel= this.event.length;
                  console.log("seleccionados");
                  console.log(this.hid_sel);
                }
              } catch (error) {                
              }
              this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
        });   

  }



  
}
